import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";

export const useStyles = makeStyles(() => ({
  containerDesktopInformation: {
    width: "40%",
    margin: "10px 30px 0px 30px",
    [theme.breakpoints.down(769)]: {
      display: "none", //
    },
  },
  wrapperInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  observation: {
    "&.MuiTypography-root": {
      color: "rgba(80, 95, 113, 0.60)",
      fontSize: 9,
      fontWeight: 500,
      margin: "15px 0px 10px 0px",
    },
  },
  titleHolder: {
    "&.MuiTypography-root": {
      color: theme.palette.text.primary,
      fontSize: 17,
      fontWeight: 600,
    },
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: 25,
    fontWeight: 600,
  },
  containerInfoHolder: {
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
    gap: "5px",
  },
  infoHolder: {
    "&.MuiTypography-root": {
      color: theme.palette.text.primary,
      fontSize: 15,
      fontWeight: 500,
    },
  },
  divider: {
    marginTop: "15px",
  },
  containerRow: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    alignItems: "center",
  },
  containerIcon: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
  },
  editText: {
    "&.MuiTypography-root": {
      color: theme.palette.text.primary,
      fontSize: 15,
      fontWeight: 700,
    },
  },
}));
